import { createFileRoute, Link } from "@tanstack/react-router";
import { Sparkles, ArrowRight } from "lucide-react";
import { useCategory } from "@/lib/use-catalog";
import { CategoryGrid } from "@/components/site/CategoryGrid";

export const Route = createFileRoute("/tivolispel")({
  head: () => ({
    meta: [
      { title: "Tivolispel & arkad — Event Sverige" },
      { name: "description", content: "Hyr lyckohjul, air hockey, boxningsmaskin, fiskdamm och fler klassiska tivoli- och arkadspel till eventet." },
      { property: "og:title", content: "Tivolispel & arkad — Event Sverige" },
      { property: "og:description", content: "Klassiska tivolispel och arkadmaskiner som livar upp vilket event som helst." },
      { property: "og:url", content: "/tivolispel" },
    ],
    links: [{ rel: "canonical", href: "https://eventsverige.se/tivolispel" }],
  }),
  component: TivolispelPage,
});

function TivolispelPage() {
  const { data, isLoading } = useCategory("tivolispel");
  const products = data?.products ?? [];

  return (
    <div>
      <section className="relative overflow-hidden bg-primary text-primary-foreground">
        <div className="absolute inset-0 bg-grain opacity-20" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 lg:py-22">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 rounded-full bg-accent/15 text-accent px-4 py-1.5 text-xs font-bold uppercase tracking-widest mb-6">
              <Sparkles className="h-3.5 w-3.5" /> Tivolispel & arkad
            </div>
            <h1 className="font-display text-5xl sm:text-6xl font-extrabold leading-[0.95]">
              Spel som skapar<br /><span className="text-accent">tivolistämning.</span>
            </h1>
            <p className="mt-6 text-lg text-primary-foreground/80 max-w-xl">
              Lyckohjul, air hockey, boxningsmaskin, fiskdamm och pilkastning.
              Publikmagneter för mässor, kickoffer, afterwork och fester.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/produkter" className="inline-flex items-center gap-2 rounded-full bg-accent text-accent-foreground px-6 py-3 font-bold hover:bg-accent/90 transition">
                Se hela sortimentet <ArrowRight className="h-4 w-4" />
              </Link>
              <Link to="/forfragan" className="inline-flex items-center gap-2 rounded-full bg-primary-foreground/10 text-primary-foreground border border-primary-foreground/20 px-6 py-3 font-semibold hover:bg-primary-foreground/15 transition">
                Gå till förfrågan
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <CategoryGrid products={products} isLoading={isLoading} placeholder="Sök i tivolispel..." />

        <div className="mt-16 rounded-2xl border border-border bg-card p-8 sm:p-10">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div>
              <h2 className="font-display text-xl font-bold">Fler kategorier att utforska</h2>
              <p className="mt-1 text-sm text-muted-foreground">Komplettera eventet med hoppborgar eller ljud & ljus.</p>
            </div>
            <div className="flex flex-wrap gap-3">
              <Link to="/hoppborgar" className="inline-flex items-center gap-2 rounded-full bg-secondary px-4 py-2 text-sm font-semibold hover:bg-secondary/70 transition">Hoppborgar <ArrowRight className="h-3.5 w-3.5" /></Link>
              <Link to="/scen-ljud-ljus" className="inline-flex items-center gap-2 rounded-full bg-secondary px-4 py-2 text-sm font-semibold hover:bg-secondary/70 transition">Scen & ljud <ArrowRight className="h-3.5 w-3.5" /></Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
